/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { GlobalState } from '../actions';

export const bettingSelector = (state: GlobalState) => state.betting;

// export const bettingTrIdSelector = (state: GlobalState) => bettingSelector(state).trId;

export const bettingGameBetsSelector = (state: GlobalState) => bettingSelector(state).gameBets;

export const bettingBetStateSelector = (state: GlobalState) => bettingSelector(state).betState;

export const bettingBetStatePerGameSelector = (gameId: string) => (state: GlobalState) =>
    bettingSelector(state).betState[Number(gameId)];

export const bettingGameBetInfoSelector = (gameId: string) => (state: GlobalState) =>
    bettingSelector(state).gameInfos[Number(gameId)];

export const bettingBetQuoteSelector = (state: GlobalState) => bettingSelector(state).betQuote;

export const bettingShowBetQuoteSelector = (state: GlobalState) => bettingSelector(state).showBetQuote;

export const bettingBetQuoteGameSelector = (state: GlobalState) => bettingSelector(state).betQuoteGame;

export const bettingTournamentRoundSelector = (state: GlobalState) => bettingSelector(state).tournamentRound;

export const bettingTournamentSelector = (state: GlobalState) => bettingSelector(state).tournament;

export const bettingIsLoadingSelector = (state: GlobalState) => bettingSelector(state).loading;
